"use strict";

exports.__esModule = true;
exports.colorPalette = exports.colorsDarkOrange = exports.colorsDarkCachoal = exports.colorsGray = exports.colorsLightGreen = exports.colorsOrange = exports.colorsRuby = exports.colorsPurple = exports.colorsPipefy = exports.darkCachoalScale6 = exports.darkCachoalScale5 = exports.darkCachoalScale4 = exports.darkCachoalScale3 = exports.darkCachoalScale2 = exports.darkCachoalScale1 = exports.darkCachoal = exports.grayScale6 = exports.grayScale5 = exports.grayScale4 = exports.grayScale3 = exports.grayScale2 = exports.grayScale1 = exports.gray = exports.lightGreenScale6 = exports.lightGreenScale5 = exports.lightGreenScale4 = exports.lightGreenScale3 = exports.lightGreenScale2 = exports.lightGreenScale1 = exports.ligthGreen = exports.darkOrangeScale6 = exports.darkOrangeScale5 = exports.darkOrangeScale4 = exports.darkOrangeScale3 = exports.darkOrangeScale2 = exports.darkOrangeScale1 = exports.darkOrange = exports.orangeScale6 = exports.orangeScale5 = exports.orangeScale4 = exports.orangeScale3 = exports.orangeScale2 = exports.orangeScale1 = exports.orange = exports.purpleScale6 = exports.purpleScale5 = exports.purpleScale4 = exports.purpleScale3 = exports.purpleScale2 = exports.purpleScale1 = exports.purple = exports.rubyScale6 = exports.rubyScale5 = exports.rubyScale4 = exports.rubyScale3 = exports.rubyScale2 = exports.rubyScale1 = exports.ruby = exports.pipefyScale6 = exports.pipefyScale5 = exports.pipefyScale4 = exports.pipefyScale3 = exports.pipefyScale2 = exports.pipefyScale1 = exports.pipefy = void 0;
// Pipefy color
var pipefy = '#0081FF';
exports.pipefy = pipefy;
var pipefyScale1 = '#339AFF';
exports.pipefyScale1 = pipefyScale1;
var pipefyScale2 = '#66B3FF';
exports.pipefyScale2 = pipefyScale2;
var pipefyScale3 = '#99CDFF';
exports.pipefyScale3 = pipefyScale3;
var pipefyScale4 = '#006AD2';
exports.pipefyScale4 = pipefyScale4;
var pipefyScale5 = '#0154A5';
exports.pipefyScale5 = pipefyScale5;
var pipefyScale6 = '#013D77'; // Ruby Red

exports.pipefyScale6 = pipefyScale6;
var ruby = '#EC4A2C';
exports.ruby = ruby;
var rubyScale1 = '#F06E56';
exports.rubyScale1 = rubyScale1;
var rubyScale2 = '#F49280';
exports.rubyScale2 = rubyScale2;
var rubyScale3 = '#F7B7AB';
exports.rubyScale3 = rubyScale3;
var rubyScale4 = '#BD3E29';
exports.rubyScale4 = rubyScale4;
var rubyScale5 = '#8E3326';
exports.rubyScale5 = rubyScale5;
var rubyScale6 = '#602723'; // Purple

exports.rubyScale6 = rubyScale6;
var purple = '#803BFF';
exports.purple = purple;
var purpleScale1 = '#9962FF';
exports.purpleScale1 = purpleScale1;
var purpleScale2 = '#B389FF';
exports.purpleScale2 = purpleScale2;
var purpleScale3 = '#CCB1FF';
exports.purpleScale3 = purpleScale3;
var purpleScale4 = '#6732D2';
exports.purpleScale4 = purpleScale4;
var purpleScale5 = '#4E2AA5';
exports.purpleScale5 = purpleScale5;
var purpleScale6 = '#342177'; // Orange

exports.purpleScale6 = purpleScale6;
var orange = '#FFA61E';
exports.orange = orange;
var orangeScale1 = '#FFB84B';
exports.orangeScale1 = orangeScale1;
var orangeScale2 = '#FFCA78';
exports.orangeScale2 = orangeScale2;
var orangeScale3 = '#FFDBA5';
exports.orangeScale3 = orangeScale3;
var orangeScale4 = '#CC881E';
exports.orangeScale4 = orangeScale4;
var orangeScale5 = '#9A6A1E';
exports.orangeScale5 = orangeScale5;
var orangeScale6 = '#674C1D'; // Dark Orange

exports.orangeScale6 = orangeScale6;
var darkOrange = '#FF7539';
exports.darkOrange = darkOrange;
var darkOrangeScale1 = '#FF9161';
exports.darkOrangeScale1 = darkOrangeScale1;
var darkOrangeScale2 = '#FFAC88';
exports.darkOrangeScale2 = darkOrangeScale2;
var darkOrangeScale3 = '#FFC8B0';
exports.darkOrangeScale3 = darkOrangeScale3;
var darkOrangeScale4 = '#CC6133';
exports.darkOrangeScale4 = darkOrangeScale4;
var darkOrangeScale5 = '#9A4D2E';
exports.darkOrangeScale5 = darkOrangeScale5;
var darkOrangeScale6 = '#673828'; // Ligth Green

exports.darkOrangeScale6 = darkOrangeScale6;
var ligthGreen = '#00CE8C';
exports.ligthGreen = ligthGreen;
var lightGreenScale1 = '#33D8A3';
exports.lightGreenScale1 = lightGreenScale1;
var lightGreenScale2 = '#66E2BA';
exports.lightGreenScale2 = lightGreenScale2;
var lightGreenScale3 = '#99EBD1';
exports.lightGreenScale3 = lightGreenScale3;
var lightGreenScale4 = '#00A876';
exports.lightGreenScale4 = lightGreenScale4;
var lightGreenScale5 = '#018260';
exports.lightGreenScale5 = lightGreenScale5;
var lightGreenScale6 = '#015C49'; // Gray

exports.lightGreenScale6 = lightGreenScale6;
var gray = '#C0D0E6';
exports.gray = gray;
var grayScale1 = '#CDD9EB';
exports.grayScale1 = grayScale1;
var grayScale2 = '#D9E3F0';
exports.grayScale2 = grayScale2;
var grayScale3 = '#E6ECF5';
exports.grayScale3 = grayScale3;
var grayScale4 = '#9AAABE';
exports.grayScale4 = grayScale4;
var grayScale5 = '#748396';
exports.grayScale5 = grayScale5;
var grayScale6 = '#4E5D6D'; // Dark cachoal

exports.grayScale6 = grayScale6;
var darkCachoal = '#293E52';
exports.darkCachoal = darkCachoal;
var darkCachoalScale1 = '#546575';
exports.darkCachoalScale1 = darkCachoalScale1;
var darkCachoalScale2 = '#7F8B97';
exports.darkCachoalScale2 = darkCachoalScale2;
var darkCachoalScale3 = '#A9B2BA';
exports.darkCachoalScale3 = darkCachoalScale3;
var darkCachoalScale4 = '#213547';
exports.darkCachoalScale4 = darkCachoalScale4;
var darkCachoalScale5 = '#192C3D';
exports.darkCachoalScale5 = darkCachoalScale5;
var darkCachoalScale6 = '#122232';
exports.darkCachoalScale6 = darkCachoalScale6;
var colorsPipefy = [pipefy, pipefyScale1, pipefyScale2, pipefyScale3, pipefyScale4, pipefyScale5, pipefyScale6];
exports.colorsPipefy = colorsPipefy;
var colorsPurple = [purple, purpleScale1, purpleScale2, purpleScale3, purpleScale4, purpleScale5, purpleScale6];
exports.colorsPurple = colorsPurple;
var colorsRuby = [ruby, rubyScale1, rubyScale2, rubyScale3, rubyScale4, rubyScale5, rubyScale6];
exports.colorsRuby = colorsRuby;
var colorsOrange = [orange, orangeScale1, orangeScale2, orangeScale3, orangeScale4, orangeScale5, orangeScale6];
exports.colorsOrange = colorsOrange;
var colorsLightGreen = [ligthGreen, lightGreenScale1, lightGreenScale2, lightGreenScale3, lightGreenScale4, lightGreenScale5, lightGreenScale6];
exports.colorsLightGreen = colorsLightGreen;
var colorsGray = [gray, grayScale1, grayScale2, grayScale3, grayScale4, grayScale5, grayScale6];
exports.colorsGray = colorsGray;
var colorsDarkCachoal = [darkCachoal, darkCachoalScale1, darkCachoalScale2, darkCachoalScale3, darkCachoalScale4, darkCachoalScale5, darkCachoalScale6];
exports.colorsDarkCachoal = colorsDarkCachoal;
var colorsDarkOrange = [darkOrange, darkOrangeScale1, darkOrangeScale2, darkOrangeScale3, darkOrangeScale4, darkOrangeScale5, darkOrangeScale6];
exports.colorsDarkOrange = colorsDarkOrange;
var colorPalette = [].concat(colorsDarkCachoal, colorsGray, colorsPipefy, colorsPurple, colorsRuby, colorsDarkOrange, colorsOrange, colorsLightGreen);
exports.colorPalette = colorPalette;